export enum ResponsibilityType {
    F = 'F',
    V = 'V',
    Vb = 'Vb'
}